import Completed from 'components/HomeTabs/Completed/Completed'
import HomeAdmin from 'components/HomeTabs/HomeAdmin/HomeAdmin'
import HomeLawyer from 'components/HomeTabs/HomeLawyer/HomeLawyer'
import HomeManager from 'components/HomeTabs/HomeManager/HomeManager'
import RenewableContracts from 'components/HomeTabs/RenewableContracts/RenewableContracts'
import Tasks from 'components/HomeTabs/Tasks/Tasks'
import ApplicationTab from '../components/HomeTabs/ApplicationTab/ApplicationTab'

export const SIGN_IN_PATH = '/sign-in'
export const HOME_PATH = '/home'
export const LEGAL_PATH = '/legal'
export const TASKS_PATH = '/tasks'
export const FINES_PATH = '/fines'
export const RENEWABLE_CONTRACTS = '/renewable-contracts'
export const COMPLETED_PATH = '/complete'
export const CONTRACT_PATH = '/contract'
export const APPLICATION_PATH = '/applications'

export const adminRoutes = [
  {
    label: 'Новые контракты',
    name: 'homeAdmin',
    path: HOME_PATH,
    component: HomeAdmin
  },
  {
    label: 'Контракты в работе',
    name: 'tasks',
    path: TASKS_PATH,
    component: Tasks
  },
  {
    label: 'В работе штрафы',
    name: 'fines',
    path: FINES_PATH,
    component: Tasks
  },
  {
    label: 'Legal',
    name: 'legal',
    path: LEGAL_PATH,
    component: HomeLawyer
  },
  {
    label: 'Завершенные',
    name: 'completed',
    path: COMPLETED_PATH,
    component: Completed
  },
  {
    label: 'Заявления',
    name: 'application',
    path: APPLICATION_PATH,
    component: ApplicationTab
  }
]

export const managerRoutes = isSoftManager => {
  const baseRoutes = [
    {
      label: 'В работе',
      name: 'homeManager',
      path: HOME_PATH,
      component: HomeManager
    },
    {
      label: 'Legal',
      name: 'legal',
      path: LEGAL_PATH,
      component: HomeLawyer
    },
    {
      label: 'В работе штрафы',
      name: 'fines',
      path: FINES_PATH,
      component: Tasks
    },
    {
      label: 'Завершенные',
      name: 'completed',
      path: COMPLETED_PATH,
      component: Completed
    },
    {
      label: 'Мои заявления',
      name: 'application',
      path: APPLICATION_PATH,
      component: ApplicationTab
    }
  ]

  return baseRoutes
}

export const lawyerRoutes = [
  {
    label: 'Новые контракты',
    name: 'home',
    path: HOME_PATH,
    component: HomeLawyer
  },
  {
    label: 'В работе',
    name: 'tasks',
    path: TASKS_PATH,
    component: Tasks
  },
  {
    label: 'Завершенные',
    name: 'renewable-contracts',
    path: RENEWABLE_CONTRACTS,
    component: RenewableContracts
  }
]


export const contractsRoutes = [`${CONTRACT_PATH}/:id`]
export const applicationRoutes = [`${APPLICATION_PATH}/:id`]
